import React, { useEffect, useState } from "react";
import "./EqStudentFinancialsBoard.scss";
import { useTranslation } from 'react-i18next';
import { Row, Col, DatePicker, Button, Tabs, Modal, Input } from "antd";
import moment, { Moment } from "moment";
import { PDFViewer } from "@react-pdf/renderer";
import TabPane from "antd/lib/tabs/TabPane";

import Api from "../../shared/Api";
import { ApiEndpoints, GenericMessage, ticksToMilliSeconds } from "../../shared/Common";
import { ISelectProps } from "../../shared/Interfaces";
import { EqEventAccessType, paymentStatusType } from "../../shared/enums";
import { IOptions } from "../../shared/interfaces/schoolTraining/IGetSchoolTrainingDto";
import { EqFinancialDto, EqProductFinancialDto } from "../../shared/interfaces/Financials/IFinancials";

import EqSelect from "../../custom/eqSelect/EqSelect";
import EqFinancialsList from "../../eqTrainer/eqFinancialsList/EqFinancialsList";
import EqProductFinancialsList from "../../eqTrainer/FinancialsBoard/eqProductFinancialsList/EqProductFinancialsList";
import EqFinancialPdfView from "../../custom/eqFinancialPdfView/EqFinancialPdfView";
import EqButton from "../../custom/eqButton/EqButton";
import AnimationDiv from "../../custom/animationDiv/AnimationDiv";
import RevealList from "../../custom/RevealList/RevealList";
import EqFinancialsListPublicEvent from "../../eqTrainer/eqFinancialsListPublicEvent/EqFinancialsListPublicEvent";
import { IEqProductFinancial } from "../../eqTrainer/FinancialsBoard/eqProductFinancialsList/eqProductFinancial/EqProductFinancial";
import { CourseLessonOrderEnt } from "../../shared/general/IStudentUnpaidOrders";

export type FinancialItem = 
| StudentFinancialDto
| IEqProductFinancial;
// also add public event dto
export interface StudentFinancialDto extends EqFinancialDto {
  selected: boolean;
  display: boolean;
  eventClass:{ //for pulbic event
    price: number
  }
}

export interface StudentProductFinancialDto extends EqProductFinancialDto {
  selected: boolean;
  display: boolean;
} 

interface StudentCourseFinancialDto extends CourseLessonOrderEnt {
  selected: boolean;
  display: boolean;
}

interface FinancialFilters {
  fromDate?: Moment | null;
  toDate?: Moment | null;
  selectedPaymentStatuses: string[];
  selectedProducts?: string[];
  selectedCourses?: string[];
  studentsName: string;
  eventTitle: string;
}
interface IEqStudentFinancialsBoardProps {
  // Add any props if needed
}

  const EqStudentFinancialsBoard: React.FC<IEqStudentFinancialsBoardProps> = () => {
    const { Search } = Input;
    const { t } = useTranslation();
    
    const [isPDFVisible, setIsPDFVisible] = useState(false);
    const [messageString, setMessageString] = useState("");
    
    const [fromDate, setFromDate] = useState<Moment | null>(null);
    const [toDate, setToDate] = useState<Moment | null>(null);
    
    const [selectedPaymentStatuses, setSelectedPaymentStatuses] = useState<string[]>([]);
    const [paymentStatusOptions, setPaymentStatusOptions] = useState<IOptions[]>([]);
    
    const [selectedProducts, setSelectedProducts] = useState<string[]>([]);
    const [productOptions, setProductOptions] = useState<IOptions[]>([]);
    
    const [selectedCourses, setSelectedCourses] = useState<string[]>([]);
    const [courseOptions, setCourseOptions] = useState<IOptions[]>([]);
    
    const [tabKey, setTabKey] = useState("1");
    const [productFinancialList, setProductFinancialList] = useState<IEqProductFinancial[]>([]);
    const [trainingFinancialList, setTrainingFinancialList] = useState<StudentFinancialDto[]>([]);
    const [eventFinancialList, setEventFinancialList] = useState<StudentFinancialDto[]>([]);
    const [courseFinancialList, setCourseFinancialList] = useState<IEqProductFinancial[]>([]);
    
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [filterBox, setFilterBox] = useState(true);
    const [studentsName, setStudentsName] = useState("");
    const [eventTitle, setEventTitle] = useState("");
    const [search, setSearch] = useState({
      searchVal: "",
    });


// Create filters object once
const currentFilters = {
  fromDate,
  toDate,
  selectedPaymentStatuses,
  selectedProducts,
  selectedCourses,
  studentsName,
  eventTitle
};

// Apply filters

    
  useEffect(() => {
    GetAllActivityFinancials();
    GetStudentEventFinancials()
    GetAllProductFinancials();
    createPaymentStatusTypes();
    GetStudentCourseFinancials();

  }, []);


  const GetStudentEventFinancials = () => {
    Api.get<StudentFinancialDto[]>(ApiEndpoints.Financial.GetStudentEventFinancials)
        .then((response) => {
            if (response && response.status === 200) {
                const data = response.data ? [...response.data] : [];

                data.forEach((evt) => {
                    evt.selected = false;
                    evt.display = false;
                });
                setEventFinancialList(data);
            } else {
                setMessageString(GenericMessage(response.status));
            }
        })
        .catch((error) => {
            setMessageString(GenericMessage(error.response.status));
        });
};


  const GetAllActivityFinancials = () => {
    Api.get<StudentFinancialDto[]>(ApiEndpoints.Financial.GetStudentActivityFinancials)
      .then((response) => {
        if (response && response.status === 200) {
          const data = response.data ? [...response.data] : [];
          const trainings = data?.filter(
            (opt) => opt?.event?.accessType === EqEventAccessType.Private
          );
          trainings.forEach((training) => {
            training.selected = false;
            training.display = false;
          });

          const events = data?.filter(
            (opt) => opt?.event?.accessType === EqEventAccessType.Public
          );
          events.forEach((event) => {
            event.selected = false;
            event.display = false;
          });

          setTrainingFinancialList(trainings);
          // setEventFinancialList(events);
        } else {
          setMessageString(GenericMessage(response.status));
        }
      })
      .catch((error) => {
        setMessageString(GenericMessage(error.response.status));
      });
  };

  const GetAllProductFinancials = () => {
    Api.get<StudentProductFinancialDto[]>(ApiEndpoints.Financial.GetStudentProductFinancials)
      .then((response) => {
        if (response && response.status === 200) {
          const data = response.data ? [...response.data] : [];
          data.forEach((item) => {
            item.selected = false;
            item.display = false;
          });
          // setProductFinancialList(data);
          var mappedProductFinanceData = mapProductFinanceData(data);
                    setProductFinancialList(mappedProductFinanceData);
          createProductList(data);
        } else {
          setMessageString(GenericMessage(response.status));
        }
      })
      .catch((error) => {
        setMessageString(GenericMessage(error.response.status));
      });
  };

  const mapProductFinanceData = (data: StudentProductFinancialDto[]): IEqProductFinancial[] => {
    return data.map(item => ({
      id: item.id,
      name: `${item.student?.firstName} ${item.student?.lastName}`,
      email: item.student?.email,
      title: item.product?.title,
      date: item.payment?.paymentDate,
      price: item.product?.price,
      vat: Number(item.product.vat),
      status: Number(item.payment?.status),
      isDisplay: false,
      isNotVAT: false,
      selected: false,
      entityName: t("Product"),
    }));
  };



    

    const GetStudentCourseFinancials = () => {
      Api.get<StudentCourseFinancialDto[]>(ApiEndpoints.Financial.GetStudentCourseFinancials)
          .then((response) => {
              if (response && response.status === 200) {
                  const data = response.data ? [...response.data] : [];
                  data.forEach((item) => {
                      item.selected = false;
                      item.display = false;
                  });
                  var mappedProductFinanceData = mapCourseFinanceData(data);
                  setCourseFinancialList(mappedProductFinanceData);
                  createCourseList(mappedProductFinanceData);
              } else {
                  setMessageString(GenericMessage(response.status));
              }
          })
          .catch((error) => {
              setMessageString(GenericMessage(error.response.status));
          });
  };


  
  const createCourseList = (items: IEqProductFinancial[]) => {
    const courseTitlesMap = new Map<string, IOptions>();
    
    items.forEach(item => {
      const title = item.title;
      if (title) {
        courseTitlesMap.set(title, {
          key: title,
          value: title,
          label: title,
        });
      }
    });
    
    setCourseOptions(Array.from(courseTitlesMap.values()));
  };


  const mapCourseFinanceData = (data: Array<StudentCourseFinancialDto>): Array<IEqProductFinancial> => {
      var entityName = t("course");
      var out: Array<IEqProductFinancial> = data.map((item) => {
          console.log(item?.payment?.status);
          return {
            id:item.id,

              name: item.student?.firstName + " " + item.student?.lastName,
              email: item.student?.email,
              title: item.course ? item.course.title : item?.courseLesson?.course.title,
              date: item?.payment?.createdDate && ticksToMilliSeconds(item?.payment?.createdDate) ,
              price: item.course ? item.course.coursePrice : item?.courseLesson?.price,
              vat: item.course?.vat,
              // status: paymentStatusType[item?.status],
              status: item?.payment?.status,
              isDisplay: false,
              isNotVAT: false,
              selected: false,
              entityName: entityName,
          } as IEqProductFinancial;
      });

      return out;
  };


  const filterFinancialsByDate = (financialList: any[]) => {
    let filteredList = financialList;
    //date
    if (fromDate && toDate) {
      const startOfFromDate = moment(fromDate).startOf("day");
      const endOfToDate = moment(toDate).endOf("day");
      filteredList = filteredList.filter((item) => {
         let paymentDate = moment();
         if ('payment' in item) {
          paymentDate = item.payment ? moment(item.payment.paymentDate) : moment();
        } 
        // Handle IEqProductFinancial
        else {
          paymentDate = moment(item.date);
        }
                       return paymentDate.isBetween(startOfFromDate, endOfToDate);
      });
    }
    //status
    //status
        if (selectedPaymentStatuses.length > 0) {
            filteredList = filteredList.filter((item) => {
                if (item.payment) {
                  return  selectedPaymentStatuses.includes(item?.payment?.status + "");
                } else {
                  return   selectedPaymentStatuses.includes(item.status + "");
                }
            });
        }

       //Product
       if (selectedProducts && selectedProducts.length > 0) {
        filteredList = filteredList.filter((item) => {
            return selectedProducts.includes(item?.title + "");
        });
    }
    //Course
    if (selectedCourses && selectedCourses.length > 0) {
        filteredList = filteredList.filter((item) => {
            return selectedCourses.includes(item?.title + "");
        });
    }

    //name or email
    if (studentsName && studentsName.length > 0) {
      const searchName = studentsName.toLowerCase(); // Convert the search name to lowercase for a case-insensitive search
      filteredList = filteredList.filter((item) => {
        const studentName = item?.user?.firstName;
        const lastName = item?.user?.lastName;
        const username = item?.user?.email;
        //Product
        const name_Pro = item?.name;
        const username_Pro = item?.email;
        return (
            (studentName &&
                (studentName + " " + lastName).toLowerCase().includes(searchName)) ||
            (name_Pro && name_Pro.toLowerCase().includes(searchName)) ||
            (username && username.toLowerCase().includes(searchName)) ||
            (username_Pro && username_Pro.toLowerCase().includes(searchName))
        );
      });
    }
    //title
    if (eventTitle && eventTitle.length > 0) {
      const searchTitle = eventTitle.toLowerCase(); // Convert the search name to lowercase for a case-insensitive search
      filteredList = filteredList.filter((item) => {
        const eventName = item?.event?.title;
        const productName = item?.title;

        return (
          (eventName && eventName.toLowerCase().includes(searchTitle)) ||
          (productName && productName.toLowerCase().includes(searchTitle))
        )
          ;
      });
    }

    return filteredList;
  };


  const filterIEqProductFinancial = (financialList: IEqProductFinancial[],filters: FinancialFilters) => {
    let filteredList = financialList;
    //date
    if (fromDate && toDate) {
      const startOfFromDate = moment(fromDate).startOf("day");
      const endOfToDate = moment(toDate).endOf("day");
      filteredList = filteredList.filter((item) => {
         let  paymentDate = moment(item.date);
       
                       return paymentDate.isBetween(startOfFromDate, endOfToDate);
      });
    }
    //status
    //status
        if (selectedPaymentStatuses.length > 0) {
            filteredList = filteredList.filter((item) => {
              return   selectedPaymentStatuses.includes(item.status + "");
            });
        }

       //Product
       if (selectedProducts && selectedProducts.length > 0) {
        filteredList = filteredList.filter((item) => {
            return selectedProducts.includes(item?.title + "");
        });
    }
    //Course
    if (selectedCourses && selectedCourses.length > 0) {
        filteredList = filteredList.filter((item) => {
            return selectedCourses.includes(item?.title + "");
        });
    }

    //name or email
    if (studentsName && studentsName.length > 0) {
      const searchName = studentsName.toLowerCase(); // Convert the search name to lowercase for a case-insensitive search
      filteredList = filteredList.filter((item) => {
      
        //Product
        const name_Pro = item?.name;
        const username_Pro = item?.email;
        return (
            (name_Pro && name_Pro.toLowerCase().includes(searchName)) ||
            (username_Pro && username_Pro.toLowerCase().includes(searchName))
        );
      });
    }
    //title
    if (eventTitle && eventTitle.length > 0) {
      const searchTitle = eventTitle.toLowerCase(); // Convert the search name to lowercase for a case-insensitive search
      filteredList = filteredList.filter((item) => {
        const productName = item?.title;

        return (
          (productName && productName.toLowerCase().includes(searchTitle))
        )
          ;
      });
    }

    return filteredList;
  };

  const filterStudentFinancialDto  = (financialList: StudentFinancialDto[],filters: FinancialFilters) => {
    let filteredList = financialList;
    
    //date
    if (fromDate && toDate) {
      const startOfFromDate = moment(fromDate).startOf("day");
      const endOfToDate = moment(toDate).endOf("day");
      filteredList = filteredList.filter((item) => {
         let paymentDate = moment();

         
                       if (item.payment?.paymentDate) paymentDate = moment(item.payment.paymentDate);
                       else paymentDate = moment(item.paymentDate)
       
                       return paymentDate.isBetween(startOfFromDate, endOfToDate);
      });
    }
    //status
    //status
        if (selectedPaymentStatuses.length > 0) {
            filteredList = filteredList.filter((item) => {
                if (item.payment) {
                  return  selectedPaymentStatuses.includes(item?.payment?.status + "");
                } 
            });
        }



    //name or email
    if (studentsName && studentsName.length > 0) {
      const searchName = studentsName.toLowerCase(); // Convert the search name to lowercase for a case-insensitive search
      filteredList = filteredList.filter((item) => {
        const studentName = item?.user?.firstName;
        const lastName = item?.user?.lastName;
        const username = item?.user?.email;
        //Product
       
        return (
            (studentName &&
                (studentName + " " + lastName).toLowerCase().includes(searchName)) ||
            
            (username && username.toLowerCase().includes(searchName)) 
        );
      });
    }
    //title
    if (eventTitle && eventTitle.length > 0) {
      const searchTitle = eventTitle.toLowerCase(); // Convert the search name to lowercase for a case-insensitive search
      filteredList = filteredList.filter((item) => {
        const eventName = item?.event?.title;
       

        return (
          (eventName && eventName.toLowerCase().includes(searchTitle)) 
        )
          ;
      });
    }

    return filteredList;
  };

  const filteredTrainings = filterStudentFinancialDto(trainingFinancialList, currentFilters);
  const filteredEvents = filterStudentFinancialDto(eventFinancialList, currentFilters);
  const filteredProducts = filterIEqProductFinancial(productFinancialList, currentFilters);
  const filteredCourses = filterIEqProductFinancial(courseFinancialList, currentFilters);
  

  const searchNameClick = (searchStr: string) => {
    setSearch({ ...search, searchVal: searchStr });
    setStudentsName(searchStr)

    // const filteredFinancials = filterFinancialsByDate(financials);
    // setFinancials(filteredFinancials);
  };
  const searchEventClick = (searchStr: string) => {
    setSearch({ ...search, searchVal: searchStr });
    setEventTitle(searchStr)

    // const filteredFinancials = filterFinancialsByDate(financials);
    // setFinancials(filteredFinancials);
  };
  const createPaymentStatusTypes = () => {
    const types:IOptions[] = [];
    for (const x in paymentStatusType) {
      if (!isNaN(Number(x))) {
        types.push({
          key: x,
          value: getPaymentStatusClass(x),
          label: paymentStatusType[x],
        });
      }
    }
    setPaymentStatusOptions(types);

  };
  const getPaymentStatusClass = (status: string): string => {
    switch (status) {
      case paymentStatusType.Paid.toString(): return "green";
      case paymentStatusType.UnpaidButAttending.toString(): return "red";
      case paymentStatusType.StudentCancelled.toString(): return "purple";
      default: return "orange";
    }
  };

  const handleGeneratePDF = () => {
    setIsPDFVisible(true);
    setIsModalVisible(true);
  };

  const paymentFilterOptions = [
    {
        key: "1",
        value: t("paid"),
        label: t("paid"),
    },
    {
        key: "5",
        value: t("Refunded"),
        label: t("Refunded"),
    },
];


const statusProps: ISelectProps = {
  mode: "multiple",
  placeholder: t("Select status"),
  isTag: true,
  defaultSelectedValue: selectedPaymentStatuses,
  options: paymentFilterOptions,
  classNames: "eq-multiSelect eq-searchSelect extra-height",
  changeFunc: setSelectedPaymentStatuses,
};

const createProductList = (items: StudentProductFinancialDto[]) => {
  const productTitlesMap = new Map<string, IOptions>();
  
  items.forEach(item => {
    const title = item.product?.title;
    if (title) {
      productTitlesMap.set(title, {
        key: title,
        value: title,
        label: title,
      });
    }
  });
  
  setProductOptions(Array.from(productTitlesMap.values()));
};



  const productProps: ISelectProps = {

    classNames: `eq-multiSelect eq-searchSelect`,
    placeholder: t("product"),
    mode: "multiple",
    isTag: false,
    defaultSelectedValue: selectedProducts ? selectedProducts : [],
    options: productOptions,
   
    changeFunc: setSelectedProducts,
  };

  const courseProps: ISelectProps = {
        classNames: `eq-multiSelect eq-searchSelect`,
        placeholder: t("RidingCourse"),
        mode: "multiple",
        isTag: false,
        defaultSelectedValue: selectedCourses ? selectedCourses : [],
        options: courseOptions,
           changeFunc: setSelectedCourses,

    };
  const clearFilters = () => {
    setFromDate(null);
    setToDate(null);
    setSelectedPaymentStatuses([]);
    setSelectedProducts([]);
    setStudentsName("");
    setEventTitle("");
  };

  const onChangeTab = (key: string) => {
    console.log(key);
    clearFilters();
    setTabKey(key);
  };

  const showModal = () => {
    setIsModalVisible(true);
  };
  const showFilterBox = () => {
    setFilterBox(!filterBox);
  };

  // Function to handle the modal close event
  const handleCancel = () => {
    setIsModalVisible(false);
  };

  // financials.map(
  //     (f: IEqFinancialDetail, index: number) => {
  //         f.display = (index == 0 ? true : false);
  //     }
  // );
  // const icon = React.createElement(
  //     'span',
  //     { className: "eq-fb-filter" },
  //     React.createElement(
  //         'img',
  //         { alt: "", src: "/Filter.svg" }
  //     )
  // )

  return (
    <>
      <AnimationDiv>


        <div className="eq-FinancialsBoard-container">
          <Row className="eq-FinancialsBoard-row" justify="space-between">
            <Col className="eq-FinancialsBoard-col">
              <h3 className="eq-FinancialsBoard-heading">{t("financials")}</h3>
            </Col>
            <Col>
              <Button
                type="primary"
                className="pdf-generate"
                onClick={handleGeneratePDF}
              >
                {t("generatePDF")}
              </Button>
            </Col>
          </Row>
          {filterBox && (
            <Row>
              <Col span={24} className="filters">
                {/* <div className="filters"> */}
                <Row gutter={[16, 16]} className="filter-type">
                  <Col className="location-col" xs={24} sm={24} md={12} lg={11}>
                    <Row className="location-selector">
                      <Col xs={6} sm={5} md={6} lg={5}>
                        <label className="picker-label">{t("student")}</label>
                      </Col>
                      <Col className="location-input" flex="auto">
                        <Search
                          placeholder={t("searchNameMail")}
                          onChange={(e) => searchNameClick(e.target.value)}
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col className="radius-col" xs={24} sm={24} md={12} lg={11}>
                    <Row className="radius-selector">
                      <Col xs={6} sm={5} md={6} lg={5}>
                        <label className="picker-label">
                        {tabKey === "1"
                                                        ? t("training")
                                                        : tabKey === "2"
                                                        ? t("event")
                                                        : tabKey === "3"
                                                        ? t("Product")
                                                        : t("RidingCourse")}
                        </label>
                      </Col>
                      <Col className="radius-input" flex="auto">
                        {tabKey === "1" || tabKey === "2" ?
                          (

                            <Search
                              className="eq-filter-radius eq-input-info"
                              placeholder={t("searchByTitle")}
                              onChange={(e) => searchEventClick(e.target.value)}
                            />
                          ) : tabKey === "3" ? (
                            <EqSelect {...productProps}></EqSelect>
                        ) : (
                            <EqSelect {...courseProps}></EqSelect>
                        )}
                      </Col>
                    </Row>
                  </Col>

                  <Col className="date-col " xs={24} sm={24} md={12} lg={11}>
                    <Row className="date-selector  start-date-selector">
                      <Col xs={6} sm={5} md={6} lg={5} >
                        <label className="picker-label">{t("startDate")}</label>
                      </Col>
                      <Col className="date-input" flex="auto">

                        <DatePicker
                          placeholder={t("selectDate")}
                          className="eq-filter-radius eq-input-info"
                          onChange={(date) => setFromDate(date)}
                          value={fromDate && fromDate.isValid() ? fromDate : null}
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col className="date-col" xs={24} sm={24} md={12} lg={11}>
                    <Row className="date-selector">
                      <Col xs={6} sm={5} md={6} lg={5}>
                        <label className="picker-label">
                          {t("endDate")}
                        </label>
                      </Col>
                      <Col className="date-input" flex="auto">
                        <DatePicker
                          placeholder={t("selectDate")}
                          className="eq-filter-radius eq-input-info"
                          onChange={(date) => setToDate(date)}
                          value={toDate && toDate.isValid() ? toDate : null}
                        />
                      </Col>
                    </Row>
                  </Col>

                  <Col className="categories-col " xs={24} sm={24} md={12} lg={11}>
                  <Row className="categories-selector">
                    <Col xs={6} sm={5} md={6} lg={5}>
                      <label className="picker-label">{t("status")}</label>
                    </Col>

                    <Col className="categories-input" flex="auto">
                      <EqSelect {...statusProps}></EqSelect>
                    </Col>

                  </Row>
                </Col>


                  <Col className="search-col" xs={24} sm={24} md={12} lg={11}>
                    <div className="search">

                      <EqButton classNames="eq-input-info" type="primary" htmlType="button">
                        {t("search")}
                      </EqButton>
                    </div>

                  </Col>
                </Row>

              </Col>
            </Row>

          )}
          <Tabs defaultActiveKey="1" onChange={onChangeTab}>
            <TabPane tab={t("trainings")} key="1">
              <div className="list">
                <RevealList>
                  <EqFinancialsList
                    financialsList={filteredTrainings}
                    accessType={EqEventAccessType.Private}
                  />
                </RevealList>
              </div>
            </TabPane>
            <TabPane tab={t("events")} key="2">
              <RevealList>
                {/* <EqFinancialsList
                  financialsList={filterFinancialsByDate(EventFinancialList)}
                  accessType={EqEventAccessType.Public}
                /> */}
                 <EqFinancialsListPublicEvent
                                    financialsList={filteredEvents}
                                />
              </RevealList>
            </TabPane>
            <TabPane tab={t("products")} key="3">
              <RevealList>
                <EqProductFinancialsList
                 entityName={t("Product")}
                 financialsList={filteredProducts}
                />
              </RevealList>
            </TabPane>
            <TabPane tab={t("courses")} key="4">
                            <RevealList>
                                <EqProductFinancialsList
                                    entityName={t("ridingCourse")}
                                    isNotVAT={false}
                                    financialsList={filteredCourses}
                                />
                            </RevealList>
                        </TabPane>
          </Tabs>

          <Modal
            title="PDF Viewer"
            open={isModalVisible}
            onCancel={handleCancel}
            footer={null} // Hide the footer if you don't need it
            width={1050} // Adjust the width as needed
          >
            <PDFViewer className="pdf-viewer" width={1000} height={1000}>
              <EqFinancialPdfView
                financialsList={
                  tabKey === "2"
                    ? filteredEvents
                    : tabKey === "3"
                    ? filteredProducts
                    : tabKey === "1"
                    ? filteredTrainings
                    : filteredCourses
                }
                type={
                  tabKey === "2"
                    ? "Event"
                    : tabKey === "1"
                      ? "Training"
                      : tabKey === "3"?"Product":"Course"
                }
              />
            </PDFViewer>
          </Modal>
        </div>
      </AnimationDiv>
    </>
  );
};

export default EqStudentFinancialsBoard;
